import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { IoBulbOutline } from 'react-icons/io5';
import { hasMinimumRole } from '../../utils/permissions';

// Topbar entry point to the Canny feedback boards (/dashboard/feedback),
// sitting next to the changelog gift icon. The board is a full surface, so
// this navigates to a page rather than opening a popover like the changelog.
// Trainer-facing (like the changelog) — hidden for clients.
const FeedbackIcon = () => {
  const history = useHistory();
  const role = useSelector((s) => s.auth?.user?.role);

  if (!hasMinimumRole(role, 'trainer')) return null;

  return (
    <button
      type="button"
      aria-label="Feature requests"
      title="Feature requests"
      onClick={() => history.push('/dashboard/feedback')}
      style={{
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        width: '20px',
        height: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '20px',
        color: 'var(--color-primary-text, #1f2937)',
        transition: 'all 0.3s ease',
        position: 'relative',
        padding: '0',
      }}
    >
      <IoBulbOutline />
    </button>
  );
};

export default FeedbackIcon;
